import { Typography } from "@material-ui/core";
import { Documentation } from "../models/Documentation";
import Timeoff from "../models/Timeoff";

import { TimeOffStatus } from "../utils/enums/TimeOffStatus";
import RoleUtils from "../utils/RoleUtils";
import { AppDialog } from "./AppDialog";

interface Props {
  selectedTimeOff: Timeoff | undefined;
  onClose: () => void;
  handleOnCancelTimeOff: (data: Timeoff, status: TimeOffStatus) => void;
}

export default function TimeOffCancelDialog(props: Props) {
  const timeOffCancelled = props.selectedTimeOff?.status == TimeOffStatus.CANCELLED;
  const pendingCondition =
    props.selectedTimeOff?.status === TimeOffStatus.PENDING ||
    props.selectedTimeOff?.status.replace("_", " ") === TimeOffStatus.ADD_DOCUMENTATION;
  const statusToSet = timeOffCancelled
    ? TimeOffStatus.PENDING
    : RoleUtils.isAdmin() || pendingCondition
    ? TimeOffStatus.CANCELLED
    : TimeOffStatus.PENDING_CANCELLATION;
  if (!props.selectedTimeOff) {
    return null;
  }
  return (
    <AppDialog
      open={!!props.selectedTimeOff}
      onClose={() => props.onClose()}
      title={props.selectedTimeOff.status !== TimeOffStatus.CANCELLED ? "Cancel" : "Reopen time off"}
      content={
        <>
          {props.selectedTimeOff.status == TimeOffStatus.CANCELLED ? (
            <Typography>{`Do you want to reopen this time off?`}</Typography>
          ) : (
            <Typography>
              {RoleUtils.isAdmin() || pendingCondition ? `Are you sure to cancel it?` : `Are you sure to request cancellation?`}
            </Typography>
          )}
        </>
      }
      buttons={[{ label: "Confirm", onClick: () => props.handleOnCancelTimeOff(props.selectedTimeOff!, statusToSet) }]}
    />
  );
}
